import React, { useEffect, useRef } from 'react';
import { revealStudioBackdrop } from './studioBackdropLoading';

export default function StudioBackdrop({ visible = true }) {
  const backdrop = useRef(null);
  useEffect(() => revealStudioBackdrop(backdrop.current), [visible]);
  if (!visible) return null;
  return <div className="studio-backdrop studio-backdrop-visible" aria-hidden="true" ref={backdrop}>
    <img className="studio-backdrop-image" src="/Studio/background-1600.webp" srcSet="/Studio/background-960.webp 960w, /Studio/background-1600.webp 1600w, /Studio/background-1672.webp 1672w" sizes="100vw" alt="" decoding="async" fetchpriority="high" />
  </div>;
}
